/** eslint-disable quotes

/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { BorderedBottomTabs, NavItem, NavLink } from '@/shared/components/Tabs';
import { getLocalStorageData, setLocalStorageData } from '@/utils/LocalStorage';
import { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';

import GpuOneAssignedMachinesTable from './GpuOneAssignedMachinesTable';
import GpuOneUnAssignedMachinesTable from './GpuOneUnAssignedMachinesTable';

const GpuOneTabs = () => {
	const [tab, setTab] = useState(
		getLocalStorageData('gpuOnePageSelectedTab') || '1',
	);

	const handleTabSelect = gpuOnePageSelectedTab => {
		setTab(gpuOnePageSelectedTab);
		setLocalStorageData('gpuOnePageSelectedTab', gpuOnePageSelectedTab);
	};

	return (
		<>
			<Tab.Container activeKey={tab} onSelect={handleTabSelect}>
				<BorderedBottomTabs>
					<Nav className="nav-tabs">
						<NavItem className="unassignedMachines">
							<NavLink eventKey="1">Unassigned Machines</NavLink>
						</NavItem>
						<NavItem className="assignedMachines">
							<NavLink eventKey="2">Assigned Machines</NavLink>
						</NavItem>
					</Nav>
					<Tab.Content>
						<Tab.Pane eventKey="1" mountOnEnter>
							<GpuOneUnAssignedMachinesTable />
						</Tab.Pane>
						<Tab.Pane eventKey="2" mountOnEnter>
							<GpuOneAssignedMachinesTable />
						</Tab.Pane>
					</Tab.Content>
				</BorderedBottomTabs>
			</Tab.Container>
		</>
	);
};

export default GpuOneTabs;
